import { AvailableIntegrationFragment } from "@/apollo/types";
import { IconButton } from "@/components/elements/Button";
import IconWithBG from "@/components/elements/IconWithBG";
import Tooltip from "@/components/elements/Tooltip";
import { IntegrationLogoBox } from "@/integrations";
import { ComponentProps } from "@tw-classed/react";

export function ConnectorRecommendationItem({
  integration,
  size,
  ...props
}: {
  integration: AvailableIntegrationFragment;
  size: ComponentProps<typeof IntegrationLogoBox>["size"];
} & Omit<ComponentProps<typeof IconButton>, "icon">) {
  return (
    <Tooltip content={integration.name}>
      <IconButton
        {...props}
        icon={
          <IntegrationLogoBox
            id={integration.id}
            size={size}
            className="h-4/5 w-4/5"
          />
        }
        size={size}
        variant="ghost"
      />
    </Tooltip>
  );
}

export function ConnectorRecommendation150More(
  props: Omit<
    ComponentProps<typeof ConnectorRecommendationItem>,
    "integration"
  >,
) {
  return (
    <IconButton
      {...props}
      icon={
        <IconWithBG
          icon={<span className="h-auto w-auto text-xs font-bold">..200+</span>}
          className="h-auto w-auto"
        />
      }
      variant="solid"
    />
  );
}
